export default __webpack_public_path__ + "static/DSC_0086-762ee26412a2535a359f556c21e2a277.jpg";